module.exports = __webpack_public_path__ + "img/booking.0df8c928.svg";